/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable react/no-unstable-nested-components */
import { useIndicators } from "components/financials/modern/data/hooks";
import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import IndicatorsList from "components/financials/modern/indicators/IndicatorsList";
import type { WithoutTypename } from "lib/types/graphql";
import { Loader2Icon } from "lucide-react";
import type { IIndicatorsFilters } from "types/graphqlTypes";

interface SelectIndicatorsProps {
  filters?: IIndicatorsFilters;
  selectedIndicators: WithoutTypename<IIndicatorFieldsFragment>[];
  onSelectIndicators: (indicators: WithoutTypename<IIndicatorFieldsFragment>[]) => void;
}
export default function SelectIndicators({ filters, selectedIndicators, onSelectIndicators }: SelectIndicatorsProps) {
  const { indicators, loading } = useIndicators(filters);
  if (loading) {
    return (
      <span className="inline-flex items-center">
        <Loader2Icon className="h-6 w-6 animate-spin text-slate-400" strokeWidth={2} />
      </span>
    );
  }

  return (
    <IndicatorsList
      indicators={indicators}
      selectedIndicators={selectedIndicators}
      onSelectIndicators={onSelectIndicators}
    />
  );
}
